import { useMemo } from 'react'
import { useQuery } from 'react-query'
import { useAuth } from 'Contexts/AuthProvider'
import DmsService from 'Services/DMS/dms-api.service'

function getRetentionPeriodValue(payload) {
    if (!payload || typeof payload !== 'object') return null
    const value = payload.dataRetentionPeriod ?? payload.DataRetentionPeriod
    return value == null ? null : value
}

/**
 * Loads subscription summary for the footer line (current package name).
 */
export default function useFooterSubscriptionPackage() {
    const { currentUser, userLoaded, currentCompany } = useAuth()

    const isSuperUser = useMemo(() => currentUser?.isSuperuser?.() ?? false, [currentUser])

    const companyConfig = useMemo(() => {
        if (!isSuperUser) return {}
        return {
            headers: {
                CompanyId: currentCompany?.id,
            },
        }
    }, [isSuperUser, currentCompany?.id])

    const queryEnabled =
        userLoaded && currentUser && (!isSuperUser || Boolean(currentCompany?.id))

    const summaryQuery = useQuery(
        ['subscriptionsSummaryFooter', currentCompany?.id],
        async () => {
            let period = null
            try {
                const retentionRes = await DmsService.getSubscriptionsDataRetentionPeriod(companyConfig)
                period = getRetentionPeriodValue(retentionRes?.data)
            } catch {
                // Summary may still work without DataRetentionPeriod
            }
            return DmsService.getSubscriptionsSummary(period, companyConfig)
        },
        {
            enabled: queryEnabled,
            keepPreviousData: true,
            refetchOnWindowFocus: false,
            staleTime: 5 * 60 * 1000,
        },
    )

    const packageName = useMemo(() => {
        const summary = summaryQuery.data?.data ?? {}
        const pkg = summary.currentPackage ?? summary.CurrentPackage ?? {}
        return pkg.name ?? pkg.Name ?? null
    }, [summaryQuery.data])

    return { packageName }
}
